export const FeaturedProjects = [
    { 
        title: "JS Dates",
        tagline: "JavaScript Dates Practice",
        description: `Practice your with JavaScript date constructors! 
            Test yourself with a small, generated snippet of JavaScript. 
            Assign values to the variables for year, month, day, and hour and then click SUBMIT.
            Instructions specify local versus utc time.`,
        tech: "HTML, CSS, & JavaScript",
        bg: "jsDatesBg",
        link: "https://danielberryman.github.io/jsdates/",
        image: "js-dates.png"
    },
    { 
        title: "Beltbook", 
        tagline: "Catalog Musical Theatre Rep",
        description: `Are you a performer? Or a musical theatre lover? Check out The Beltbook! You can create
            endless books of music categorized in whatever way you want. Search by Voice Type, Character Type, Era and more! 
            `,
        tech: "React, Django/Python, Docker",
        bg: "beltbookBg",
        link: "https://thebeltbook.com",
        image: "beltbook.png"
        }
];

export const SecondaryProjects = [
    {
        title: "Daniel's Cards",
        description: "Splash Page for App Idea.",
        tech: "React",
        link: "https://danielberryman.github.io/daniels-cards/",
        bg: "danielsCardsBg"
    },
    {
        title: "Ng Mat GroupBy",
        description: "Example of doing GroupBy with Ng Material Table.",
        tech: "Angular",
        link: "https://danielberryman.github.io/angular-mat-groupby/",
        bg: "secondaryBgLightBlue"
    },
    {
        title: "Tic Tac Toe",
        description: "Weekend fun building a little tic tac toe game.",
        tech: "HTML, CSS, & JS",
        link: "https://danielberryman.github.io/tic-tac-toe/",
        bg: "secondaryBg"
    },
    {
        title: "Notes & Tuts",
        description: `Notes for quick execution across wide range of tech.`,
        tech: "Markdown",
        link: "https://github.com/danielberryman/blog-posts-and-tutorials",
        bg: "secondaryBgLightBlue"
    }
];